module.exports = __webpack_public_path__ + "img/71.413c3544.jpg";